import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { navLink } from '../../../utils/nav-link';
import { NavItem } from './NavItem';

export const Nav = () => {
    const { active_tab: activeTab } = useParams();

    useEffect( () => {
        navLink( activeTab );
    } );

    return (
        <nav className="statspro-nav">
            <ul className='statspro-nav__list'>
                <NavItem
                    path="/"
                    icon="chart-v2"
                    translationLabel="label.statspro.statsHome"
                    tabName="home"
                />
                <NavItem
                    path="/leaders"
                    icon="list-number"
                    translationLabel="label.statspro.statsLeaders"
                    tabName="leaders"
                />
            </ul>
        </nav>
    );
};